import React, { useContext, useReducer, useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, c as _slicedToArray, e as _objectSpread2, f as _defineProperty } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import { _ as _isEmpty } from './isEmpty-9e4c9724.js';
import { _ as _forEach } from './forEach-18e9e52f.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: ", ";\n  height: ", ";\n\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledRound = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.stepper.sizes.round;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.stepper.sizes.round;
}, function (_ref3) {
  var isCompleted = _ref3.isCompleted,
      theme = _ref3.theme;
  return isCompleted ? theme.components.stepper.colors.stepAfter : theme.components.stepper.colors.step;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.stepper.sizes.borderRadius;
}, function (_ref5) {
  var isCompleted = _ref5.isCompleted,
      theme = _ref5.theme;
  return isCompleted ? theme.components.stepper.boxShadows.shadow1 : theme.components.stepper.boxShadows.shadow2;
});

var StepperContext = React.createContext();
var StepperDispatchContext = React.createContext();
var StepperOnChange = React.createContext();
var StepperAdapt = React.createContext();
var StepperActiveIdContext = React.createContext();

function stepReducer(state, _ref) {
  var type = _ref.type,
      id = _ref.id;

  switch (type) {
    case 'REGISTER':
    case 'DESACTIVATE':
      return _objectSpread2({}, state, _defineProperty({}, id, false));

    case 'ACTIVATE':
      return _objectSpread2({}, state, _defineProperty({}, id, true));
  }
}

function useStepper() {
  var context = useContext(StepperContext);
  return context;
}

function useStepperDispatch() {
  var dispatch = useContext(StepperDispatchContext);

  var register = function register(id) {
    return dispatch({
      type: 'REGISTER',
      id: id
    });
  };

  var activate = function activate(id) {
    return dispatch({
      type: 'ACTIVATE',
      id: id
    });
  };

  var desactivate = function desactivate(id) {
    return dispatch({
      type: 'DESACTIVATE',
      id: id
    });
  };

  return {
    register: register,
    activate: activate,
    desactivate: desactivate
  };
}

function useOnChange() {
  var context = useContext(StepperOnChange);
  return context;
}

function useStepperAdapt() {
  var context = useContext(StepperAdapt);
  return context;
}

function useActiveId() {
  var context = useContext(StepperActiveIdContext);
  return context;
}

var StepperProvider = function StepperProvider(_ref2) {
  var children = _ref2.children,
      onClick = _ref2.onClick,
      stepperList = _ref2.stepperList;

  var _useReducer = useReducer(stepReducer, stepperList),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      stepList = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeId = _useState2[0],
      setActiveId = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      nbStep = _useState4[0],
      setNbStep = _useState4[1];

  return React.createElement(StepperActiveIdContext.Provider, {
    value: [activeId, setActiveId]
  }, React.createElement(StepperAdapt.Provider, {
    value: [nbStep, setNbStep]
  }, React.createElement(StepperContext.Provider, {
    value: stepList
  }, React.createElement(StepperOnChange.Provider, {
    value: onClick
  }, React.createElement(StepperDispatchContext.Provider, {
    value: dispatch
  }, children)))));
};

StepperProvider.defaultProps = {
  children: null,
  onClick: null,
  stepperList: {}
};
StepperProvider.propTypes = {
  /**
   * Content of the StepProvider.
   */
  children: PropTypes.any,

  /**
   * retrieves the current step.
   */
  onClick: PropTypes.any,

  /*
   * list that allows the user to choose the starting step
   */
  stepperList: PropTypes.object
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  font-family: ", ";\n  color: ", ";\n\n  :not(:last-child) {\n    margin-right: ", ";\n  }\n\n  hr {\n    position: absolute;\n    width: ", ";\n    top: ", ";\n    left: ", ";\n    margin: 0;\n    border: 0.5px solid ", ";\n    background:  ", ";\n  }\n\n  :last-child hr {\n    display: none;\n  }\n\n  @media only screen and (max-width: ", ") {\n      :not(:last-child) {\n        margin-right: 0;\n        margin-bottom: ", ";\n      }\n\n      hr {\n        width:0;\n        height: ", ";\n        top: ", ";\n        left: ", ";\n      }\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

function adaptStep(nbStep, size) {
  var reduceStep = Math.pow(0.85, nbStep);
  return css(["calc(", " * ", ")"], size, reduceStep);
}

var StyledStep = styled.li(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.stepper.fonts.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.stepper.colors.midText;
}, function (_ref3) {
  var nbStep = _ref3.nbStep,
      theme = _ref3.theme;
  return adaptStep(nbStep, theme.components.stepper.sizes.alignBar);
}, function (_ref4) {
  var nbStep = _ref4.nbStep,
      theme = _ref4.theme;
  return adaptStep(nbStep, theme.components.stepper.sizes.alignBar);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.stepper.sizes.topBar;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.stepper.sizes.leftBar;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.stepper.colors.bar;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.stepper.colors.bar;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.mobileMax;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.stepper.sizes.alignBarMobile;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.components.stepper.sizes.alignBarMobile;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.components.stepper.sizes.topBarMobile;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.components.stepper.sizes.leftBarMobile;
});

var Step = function Step(_ref14) {
  var id = _ref14.id,
      children = _ref14.children,
      value = _ref14.value;

  var _useStepperDispatch = useStepperDispatch(),
      register = _useStepperDispatch.register,
      activate = _useStepperDispatch.activate,
      desactivate = _useStepperDispatch.desactivate;

  var stepList = useStepper();
  var onClick = useOnChange();

  var _useStepperAdapt = useStepperAdapt(),
      _useStepperAdapt2 = _slicedToArray(_useStepperAdapt, 2),
      nbStep = _useStepperAdapt2[0],
      setNbStep = _useStepperAdapt2[1];

  var _useActiveId = useActiveId(),
      _useActiveId2 = _slicedToArray(_useActiveId, 2),
      activeId = _useActiveId2[0],
      setActiveId = _useActiveId2[1];

  useEffect(function () {
    if (_isEmpty(stepList)) {
      register(id);
    }

    setNbStep(function (prevNbStep) {
      return prevNbStep + 1;
    });
  }, [id, register, setNbStep, stepList]);

  var onClickStep = function onClickStep() {
    var currentStep = id;

    if (stepList[currentStep]) {
      _forEach(stepList, function (_, key) {
        if (key > currentStep) {
          desactivate(key);
        }
      });
    } else {
      _forEach(stepList, function (_, key) {
        if (key <= currentStep) activate(key);
      });
    }

    onClick && onClick(currentStep);
    setActiveId(id);
  };

  var isComplete = function isComplete() {
    return stepList[id];
  };

  return React.createElement(StyledStep, {
    onClick: onClickStep,
    "aria-current": id === activeId ? 'step' : undefined,
    "aria-checked": isComplete(),
    nbStep: nbStep
  }, React.createElement(StyledRound, {
    isCompleted: isComplete()
  }, value, React.createElement("hr", null)), children);
};

Step.defaultProps = {
  children: null,
  value: null
};
Step.propTypes = {
  /**
   * The id of the step.
   * It allows to identify each step to know if it activates and apply the modifications
   */
  id: PropTypes.string.isRequired,

  /**
   * The content of the step.
   */
  children: PropTypes.any,

  /**
   * value in the step.
   */
  value: PropTypes.string
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-family: ", ";\n  text-align: center;\n  margin-top: ", ";\n  color: ", ";\n\n  @media only screen and (max-width: ", ") {\n    position: absolute;\n    top: calc(50% - ", ");\n    left: ", ";\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabel = styled.p(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.stepper.fonts.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.stepper.fonts.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.stepper.sizes.marginTopLbl;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.stepper.colors.text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.mobileMax;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.stepper.fonts.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.stepper.sizes.leftLbl;
});

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0;\n  list-style: none;\n\n  @media only screen and (max-width: ", ") {\n    flex-direction: column;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledStepper = styled.ol(_templateObject$3(), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.mobileMax;
});

/**
 * A basic stepper
 */

var Stepper = function Stepper(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      stepList = _ref.stepList;
  return React.createElement(StyledStepper, {
    role: "navigation",
    "aria-label": "progress"
  }, React.createElement(StepperProvider, {
    onClick: onClick,
    stepperList: stepList
  }, children));
};

Stepper.defaultProps = {
  onClick: null,
  stepList: {}
};
Stepper.propTypes = {
  /**
   * The content of the stepper.
   * It can receive : Stepper.Step, Stepper.Label, Stepper.useStepList, Stepper.useStepDispatch
   */
  children: PropTypes.any.isRequired,

  /**
   * retrieves the current step
   */
  onClick: PropTypes.any,

  /*
   * list that allows the user to choose the starting step
   */
  stepList: PropTypes.object
};
Stepper.Step = Step;
Stepper.Label = StyledLabel;
Stepper.useStepList = useStepper;
Stepper.useStepDispatch = useStepperDispatch;

export default Stepper;
